import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Catalogs|Credential|Fulfillments|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.CredentialFulfillment,
	portal: 'SP',
};

type LocNameStart = 'SPCatalogCredentialFulfillment';
export type SPCatalogCredentialFulfillmentLocNames =
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}LabelId`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelNameAbbr`
	| `${LocNameStart}LabelDescription`
	| `${LocNameStart}LabelQueue`
	| `${LocNameStart}LabelExternalId`
	| `${LocNameStart}LabelElectronic`
	| `${LocNameStart}LabelAutoRequeue`;

export const spCatalogCredentialFulfillmentLocs: LocDefs<SPCatalogCredentialFulfillmentLocNames> = {
	SPCatalogCredentialFulfillmentTitlePage: {
		defaultValue: 'Credential Fulfillments',
		description: 'Page Title',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		legacyName: 'Credential.Fulfillment/CatalogsCredential.Fulfillments.Title.PageTitle',
		...sharedProperties,
	},
	SPCatalogCredentialFulfillmentTitleTab: {
		defaultValue: 'Credential Fulfillments',
		description: 'Tab Title',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		legacyName: 'Credential.Fulfillment/CatalogsCredential.Fulfillments.Title.TabTitle',
		...sharedProperties,
	},
	SPCatalogCredentialFulfillmentLabelId: {
		defaultValue: 'ID',
		description: 'Column heading for: ID.',
		displayPath: `${pathStart}ID`,
		displayType: 'Label',
		legacyName: 'Credential.Fulfillment/CatalogsCredential.Fulfillments.ColumnHeading.Id',
		...sharedProperties,
	},
	SPCatalogCredentialFulfillmentLabelName: {
		defaultValue: 'Name',
		description: 'Column heading for: Name.',
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		legacyName: 'Credential.Fulfillment/CatalogsCredential.Fulfillments.ColumnHeading.Name',
		...sharedProperties,
	},
	SPCatalogCredentialFulfillmentLabelNameAbbr: {
		defaultValue: 'Name Abbr.',
		description: 'Column heading for: Name Abbr.',
		displayPath: `${pathStart}Name Abbr`,
		displayType: 'Label',
		legacyName: 'Credential.Fulfillment/CatalogsCredential.Fulfillments.ColumnHeading.NameAbbr',
		...sharedProperties,
	},
	SPCatalogCredentialFulfillmentLabelDescription: {
		defaultValue: 'Description',
		description: 'Column heading for: Description.',
		displayPath: `${pathStart}Description`,
		displayType: 'Label',
		legacyName:
			'Credential.Fulfillment/CatalogsCredential.Fulfillments.ColumnHeading.Description',
		...sharedProperties,
	},
	SPCatalogCredentialFulfillmentLabelQueue: {
		defaultValue: 'Queue',
		description: 'Column heading for: Queue.',
		displayPath: `${pathStart}Queue`,
		displayType: 'Label',
		legacyName: 'Credential.Fulfillment/CatalogsCredential.Fulfillments.ColumnHeading.Queue',
		...sharedProperties,
	},
	SPCatalogCredentialFulfillmentLabelExternalId: {
		defaultValue: 'External ID',
		description: 'Column heading for: External ID.',
		displayPath: `${pathStart}External ID`,
		displayType: 'Label',
		legacyName:
			'Credential.Fulfillment/CatalogsCredential.Fulfillments.ColumnHeading.ExternalId',
		...sharedProperties,
	},
	SPCatalogCredentialFulfillmentLabelElectronic: {
		defaultValue: 'Electronic',
		description: 'Column heading for: Electronic.',
		displayPath: `${pathStart}Electronic`,
		displayType: 'Label',
		legacyName:
			'Credential.Fulfillment/CatalogsCredential.Fulfillments.ColumnHeading.Electronic',
		...sharedProperties,
	},
	SPCatalogCredentialFulfillmentLabelAutoRequeue: {
		defaultValue: 'Auto Requeue',
		description: 'Column heading for: Auto Requeue.',
		displayPath: `${pathStart}Auto Requeue`,
		displayType: 'Label',
		legacyName:
			'Credential.Fulfillment/CatalogsCredential.Fulfillments.ColumnHeading.AutoRequeue',
		...sharedProperties,
	},
};

export type SPCatalogCredentialFulfillmentLocType = LocMap<SPCatalogCredentialFulfillmentLocNames>;
